import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { RelaysState, IRelayState } from './types';

export const getters: GetterTree<RelaysState, RootState> = {
    getRelayState(state): (deviceNumber: string, relayNo: number) => IRelayState {
        return (deviceNumber: string, relayNo: number): IRelayState => {
            const relays = state.relays[deviceNumber];
            if (relays && relays[relayNo]) {
                return relays[relayNo];
            }
            return {
                isOn: false,
                isLoading: true,
            };
        };
    },
    areRelaysLoaded(state): (deviceNumber: string) => boolean {
        return (deviceNumber: string): boolean => {
            return state.relays[deviceNumber] ? true : false;
        };
    },
    locked(state): boolean {
        return state.locked;
    },
};
